import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=27c0ce88"
import script from "./ForgetPassword.vue?vue&type=script&lang=ts"
export * from "./ForgetPassword.vue?vue&type=script&lang=ts"
import style0 from "./ForgetPassword.vue?vue&type=style&index=0&id=27c0ce88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports